import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const ProfileIcon: React.FC<IconProps> = (props) => (

<svg width="15" height="15" viewBox="0 0 15 15" fill="currentColor" {...props}  xmlns="http://www.w3.org/2000/svg">
<path d="M9.74534 1.89199C9.17522 1.27646 8.37893 0.9375 7.50003 0.9375C6.61643 0.9375 5.81751 1.27441 5.25003 1.88613C4.6764 2.50459 4.3969 3.34512 4.46253 4.25273C4.59261 6.04336 5.9552 7.5 7.50003 7.5C9.04485 7.5 10.4051 6.04365 10.5372 4.25332C10.6037 3.35391 10.3225 2.51514 9.74534 1.89199Z" fill="currentColor"/>
<path d="M12.6564 14.0615H2.34392C2.20894 14.0633 2.07526 14.0349 1.95262 13.9785C1.82997 13.9221 1.72145 13.8391 1.63493 13.7354C1.4445 13.5078 1.36775 13.197 1.42458 12.8826C1.67185 11.5109 2.44353 10.3587 3.65642 9.5498C4.73396 8.83174 6.0989 8.43652 7.50016 8.43652C8.90143 8.43652 10.2664 8.83203 11.3439 9.5498C12.5568 10.3584 13.3285 11.5106 13.5757 12.8823C13.6326 13.1967 13.5558 13.5075 13.3654 13.7352C13.2789 13.8388 13.1704 13.9219 13.0478 13.9784C12.9251 14.0348 12.7914 14.0632 12.6564 14.0615Z" fill="currentColor"/>
</svg>



);

export default ProfileIcon;
